// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__26EZb","overflowing":"ReadFullNote_overflowing__2kYFr"};